<template>
  <div class="designs">
    <transition-group name="flip-list" class="banners" tag="div">
      <div class="card-item" v-for="banner of designData.list" :key="banner.schemeId">
        <Banner
          class="banner-scale"
          :bannerTextValue="banner.textValue"
          :textStyle="banner.textStyle"
          :bgConfig="banner.bgParameter"
          :elementImg="banner.elementSrc"
          :textInfo="banner.textInfo"
        />
        <span class="save-time">保存于: {{ filterTime(banner.time) }}</span>
        <div class="mask">
          <span class="btn" @click="toDesignDetail(banner.schemeId)"> <i class="el-icon-edit"></i>编辑 </span>
          <span class="btn" @click="delectConfirm(banner.schemeId)"><i class="el-icon-delete"></i>删除</span>
        </div>
        <div class="caption">
          <span class="count">共计 {{ banner.count }} 个尺寸</span>
          <dropdown v-if="!sizeId" :designName="'banner'" :designData="banner"></dropdown>
        </div>
      </div>
    </transition-group>
    <div class="pagination">
      <el-pagination
        v-if="designData.totalPage"
        :key="2"
        background
        layout="prev, pager, next"
        :page-count="designData.totalPage"
        @current-change="getDesginList"
        @prev-click="getDesginList(--pageIndex)"
        @next-click="getDesginList(++pageIndex)"
      >
      </el-pagination>
    </div>
    <div class="nothing" v-if="!designData.list.length">
      <span class="tips">您还没有添加内容，赶紧去添加吧</span>
      <button class="btn" @click="navigateBack">开始创意</button>
    </div>
    <el-dialog title="提示" :visible.sync="delectDialogVisible" top="25vh" width="400px" left>
      <span class="msg"><i class="iconfont icon-jingshi"></i>是否删除当前文件？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delectDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="immediateDelete(currentDesign)">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/plugins/http";
import api from "@/assets/scripts/api";
import Banner from "@/pages/banner/components/banner.vue";
import dropdown from "@/components/dropdown.vue";
export default {
  name: "designs",
  props: {
    userId: {
      type: String,
      default: "",
    },
    sizeId: {
      type: String,
      default: "",
    },
    designData: {
      type: Object,
      default: () => ({
        list: [],
        totalPage: 0,
      }),
    },
  },
  data() {
    return {
      delectDialogVisible: false,
      currentDesign: "",
      pageSize: 20,
      pageIndex: 1,
    };
  },
  components: {
    Banner,
    dropdown,
  },
  async mounted() {
    this.getDesginList(1);
  },
  methods: {
    async getDesginList(pageIndex) {
      this.pageIndex = pageIndex;
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        platformType: 1,
      };
      if (this.sizeId) {
        params.sizeId = this.sizeId;
      }
      if (this.userId) {
        params.userId = this.userId;
      }
      this.$emit("getPosters", params);
    },
    toDesignDetail(schemeId) {
      this.$emit("toDesignDetail", schemeId);
    },
    delectConfirm(id) {
      this.currentDesign = id;
      this.delectDialogVisible = true;
    },
    async immediateDelete(id) {
      let data = null;
      if (this.userId) {
        data = await http.delete(api.deleteSchemeByUser, {
          schemeId: id,
          userId: this.userId,
        });
      } else {
        data = await http.delete(api.scheme + "/" + id);
      }
      if (data.code === 10000) {
        this.getDesginList(1);
      }
      this.delectDialogVisible = false;
    },
    filterTime(timeStamp) {
      const creatTime = new Date(timeStamp);
      const year = creatTime.getFullYear();
      const month = creatTime.getMonth() + 1;
      const day = creatTime.getDate();
      return `${year}.${month < 10 ? `0${month}` : month}.${day < 10 ? `0${day}` : day}`;
    },
    navigateBack() {
      this.$emit("toDesign");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.designs {
  position: relative;
  height: calc(100vh - 166px);
  .banners {
    display: flex;
    justify-content: left;
    flex-flow: wrap;
    align-content: flex-start;
    padding: 15px;
    position: relative;
    overflow: auto;
    height: calc(100% - 50px);
    .card-item {
      position: relative;
      box-sizing: border-box;
      flex-basis: 600px;
      width: 600px;
      height: 208px;
      padding: 12px 12px 44px;
      margin: 12px;
      background-color: #fff;
      border-radius: 12px;
      .banner-scale {
        transform: scale(0.6);
        transform-origin: 0 0;
      }
    }
  }
  .pagination {
    display: flex;
    justify-content: right;
    padding: 15px;
  }
  @include scroller;
}
.flip-list-enter-active {
  transition: all 0.5s;
}
.flip-list-leave-active {
  position: absolute;
}
.flip-list-enter {
  opacity: 0;
  transform: scale(0.8);
}
.flip-list-leave-to {
  height: 0;
}
</style>
